import { render, staticRenderFns } from "./StepRegistration.vue?vue&type=template&id=d6164c2e&scoped=true"
import script from "./StepRegistration.vue?vue&type=script&lang=js"
export * from "./StepRegistration.vue?vue&type=script&lang=js"
import style0 from "./StepRegistration.vue?vue&type=style&index=0&id=d6164c2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6164c2e",
  null
  
)

export default component.exports